import axios from "axios";
import Util from "./util";

class API {
  constructor() {
    const getBaseUrl = () => {
      let url;
      switch (process.env.REACT_APP_STAGE) {
        case "production":
          url = process.env.REACT_APP_PROD_API_URL;
          break;
        case "qa":
          url = process.env.REACT_APP_QA_API_URL;
          break;
        case "development":
          url = process.env.REACT_APP_DEV_API_URL;
          break;
        case "staging":
          url = process.env.REACT_APP_STAGING_API_URL;
          break;
        default:
          url = process.env.REACT_APP_DEV_API_URL;
      }

      return url;

      console.log("url",url);


    };



  /*  console.log("getBaseUrl", getBaseUrl())

     this.base_url = getBaseUrl();*/

   
    if(window.location.hostname == "localhost"){
      console.log("inside")
      this.base_url = "https://api-uat-jarvis.lynk.co.in"
     
    }else if(window.location.hostname == "uat-jarvis.lynk.co.in" || window.location.hostname == "15.206.34.41"){
      this.base_url = "https://api-uat-jarvis.lynk.co.in"
      
    }
    else{
        console.log("outside")
       this.base_url = window.location.protocol+"//"+window.location.hostname+":8088";
    }


   
   
    this.headers = {
      "Content-Type": "application/json",
      Authorization: Util.accessCookie("token"),
    };
    this.apiversion = null;
  }

  get(endpoint, ...args) {
    let headers = this.headers;
    //let param = {};
    endpoint =
      this.apiversion === null
        ? this.base_url + endpoint
        : this.base_url + this.apiversion + "/" + endpoint;
    if (args.length > 0) {
      headers = args[0]["headers"] ? args[0]["headers"] : this.headers;
      if (args[0]["param"] !== undefined) {
        var param = args[0]["param"];
        param = Object.keys(param).map((attr) => {
          return attr + "=" + param[attr];
        });
        param = param.join("&");
      }

      endpoint = param ? endpoint + "?" + param : endpoint;
    }
    
    return axios.get(endpoint, { headers: headers })
    .catch(error => {
        if (error.response && error.response.status === 401) {
          // Handle 404 error, e.g., redirect to login page
          alert("Your session has expired , Please Re-Login.")
          console.log("404 error occurred. Redirecting to login page.");
          // You can replace the following line with your logic for redirecting to the login page
          window.location.href = "/";
        }
        // Propagate the error if it's not a 404
        throw error;
      });
  }

  get2(endpoint, ...args) {
    let headers = this.headers;
    let responseType = 'json';  // Default response type

    endpoint =
      this.apiversion === null
        ? this.base_url + endpoint
        : this.base_url + this.apiversion + "/" + endpoint;

    if (args.length > 0) {
      headers = args[0]["headers"] ? args[0]["headers"] : this.headers;
      if (args[0]["param"] !== undefined) {
        var param = args[0]["param"];
        param = Object.keys(param).map((attr) => {
          return attr + "=" + param[attr];
        });
        param = param.join("&");
      }
      endpoint = param ? endpoint + "?" + param : endpoint;

      // If responseType is passed, use it
      if (args[0]["responseType"]) {
        responseType = args[0]["responseType"];
      }
    }

    return axios.get(endpoint, { headers: headers, responseType })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          alert("Your session has expired, Please Re-Login.");
          window.location.href = "/";
        }
        throw error;
      });
  }

  post(endpoint, ...args) {
    if(this.headers.Authorization == ""){
      this.headers.Authorization = Util.accessCookie("token");
    }

    let headers = this.headers;
    let param = {};
    endpoint =
      this.apiversion === null
        ? this.base_url + endpoint
        : this.base_url + this.apiversion + "/" + endpoint;

    if (args.length > 0) {
      headers = args[0]["headers"] ? args[0]["headers"] : this.headers;
      param = args[0]["param"];
    }

    return axios.post(endpoint, param, { headers: headers })
    .catch(error => {
        if (error.response && error.response.status === 401) {
          // Handle 404 error, e.g., redirect to login page
          alert("Your session has expired , Please Re-Login.")
          console.log("404 error occurred. Redirecting to login page.");
          // You can replace the following line with your logic for redirecting to the login page
          window.location.href = "/";
        }
        // Propagate the error if it's not a 404
        throw error;
      });
  }

  
   put(endpoint, ...args) {
    if (this.headers.Authorization === "") {
      this.headers.Authorization = Util.accessCookie("token");
    }

    let headers = this.headers;
    let param = {};
    endpoint =
      this.apiversion === null
        ? this.base_url + endpoint
        : this.base_url + this.apiversion + "/" + endpoint;

    if (args.length > 0) {
      headers = args[0]["headers"] ? args[0]["headers"] : this.headers;
      param = args[0]["param"];
    }

    return axios.put(endpoint, param, { headers: headers })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          alert("Your session has expired, Please Re-Login.");
          console.log("401 error occurred. Redirecting to login page.");
          window.location.href = "/";
        }
        throw error;
      });
  }


  patch(endpoint, ...args) {
    if (this.headers.Authorization == "") {

      this.headers.Authorization = Util.accessCookie("token");
    }

    let headers = this.headers;
    let param = {};
    endpoint =
      this.apiversion === null
        ? this.base_url + endpoint
        : this.base_url + this.apiversion + "/" + endpoint;

    if (args.length > 0) {
      headers = args[0]["headers"] ? args[0]["headers"] : this.headers;
      param = args[0]["param"];
    }



    return axios.patch(endpoint, param, { headers: headers })

      .catch(error => {
        if (error.response && error.response.status === 401) {
          alert("Your session has expired, Please Re-Login.");
          console.log("401 error occurred. Redirecting to login page.");
          window.location.href = "/";
        }
        throw error;
      });
  }

  delete(endpoint, ...args) {
    let headers = this.headers;
    //let param = {};
    endpoint =
      this.apiversion === null
        ? this.base_url + endpoint
        : this.base_url + this.apiversion + "/" + endpoint;
    if (args.length > 0) {
      headers = args[0]["headers"] ? args[0]["headers"] : this.headers;
      if (args[0]["param"] !== undefined) {
        var param = args[0]["param"];
        param = Object.keys(param).map((attr) => {
          return attr + "=" + param[attr];
        });
        param = param.join("&");
      }

      endpoint = param ? endpoint + "/" + param : endpoint;
    }
    
    return axios.delete(endpoint, { headers: headers })
    .catch(error => {
        if (error.response && error.response.status === 401) {
          // Handle 404 error, e.g., redirect to login page
          alert("Your session has expired , Please Re-Login.")
          console.log("404 error occurred. Redirecting to login page.");
          // You can replace the following line with your logic for redirecting to the login page
          window.location.href = "/";
        }
        // Propagate the error if it's not a 404
        throw error;
      });
  }

  post2(endpoint, ...args) {
    const token = localStorage.getItem("auth_token") || Util.accessCookie("token");

    let headers = {
      ...this.headers,
      Authorization: token,
    };

    let param = {};

    endpoint =
      this.apiversion === null
        ? this.base_url + endpoint
        : this.base_url + this.apiversion + "/" + endpoint;

    if (args.length > 0) {
      if (args[0].headers) {
        headers = { ...headers, ...args[0].headers };
      }
      param = args[0].param;
    }

    if (param instanceof FormData) {
      const formHeaders = { ...headers };
      delete formHeaders["Content-Type"]; // Let browser set the correct boundary
      return axios.post(endpoint, param, { headers: formHeaders });
    }

    // ✅ Send as raw object, not wrapped inside { param }
    return axios.post(endpoint, param, { headers })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          alert("Your session has expired. Please Re-Login.");
          window.location.href = "/";
        }
        throw error;
      });
  }



}

const callapiobj = new API();
export default callapiobj;



export const base_url = callapiobj.base_url; // Export base_url
export const GOOGLE_CLIENT_TOKEN = process.env.REACT_APP_GOOGLE_CLIENT_TOKEN;